<template>
    <div class="component-group"
         :class="{
            active: !!isStatusOther || !!isStatusYes
         }"
    >
        <form-group :label="`${$t(`${translationsGroup}.apheresis_platelet_plasma_donor`)}`"
                    :errors="errors"
                    label-for="bloodDonorStatus"
                    name="plasmaBloodDonorStatus"
        >
            <select-box :options="getOptions"
                        :value="status"
                        :disabled="isLoading"
                        :placeholder="`${$t(`${placeholderGroup}.select_option`)}`"
                        id="plasmaBloodDonorStatus"
                        name="plasmaBloodDonorStatus"
                        @update="onUpdateBloodDonorStatus"
            />
        </form-group>
        <div v-if="isStatusYes">
            <label class="form-label">{{ $t(`${translationsGroup}.afferent_donation_stamp_image`)}}</label>
            <file-upload :value="stamps"
                         :multiple="true"
                         :download-files="hasPermission('Attachments - Download')"
                         :delete-files="hasPermission('Attachments - Remove')"
                         :preview-files="true"
                         name="plasma_donor_stamps"
                         id="plasma_donor_stamps"
                         @update="onUpdateBloodDonorStatus"
                         @remove-file-uploaded="onDeleteAttachmentEvent"
                         @download-uploaded-file="onDownloadAttachmentEvent"
                         @preview-uploaded-file="onPreviewAttachmentEvent"
            />
        </div>
        <form-group v-if="!!isStatusOther"
                    :errors="errors"
                    :label="`${$t(`${placeholderGroup}.enter_other_status`)}`"
                    name="plasmaBloodDonorStatusOther"
        >
            <input :value="statusOther"
                   name="plasmaBloodDonorStatusOther"
                   class="blood-donors-create-update-input"
                   :placeholder="$t(`${placeholderGroup}.enter_other_status`)"
                   @input="onUpdateBloodDonorStatus('plasmaBloodDonorStatusOther', $event.target.value)"
            />
        </form-group>
    </div>
</template>

<script>
import SelectBox from '../../../../../../Components/Forms/SelectBox/SelectBox';
import FormGroup from '../../../../../../Components/Forms/Holders/FormGroup';
import FileUpload from '../../../../../../Components/Forms/FileUpload/FileUpload';

export default {
    name: 'PlasmaBloodDonorStatusSelect',
    inject: [
        '$can',
    ],
    emits: [
        'download-uploaded-file',
        'remove-uploaded-file',
        'update',
    ],
    components: {
        FileUpload,
        SelectBox,
        FormGroup
    },
    props: {
        status: {},
        statusOther: {},
        stamps: {},
        errors: {
            default: null
        },
        translationsGroup: {
            type: String,
            default: 'words'
        },
        placeholderGroup: {
            type: String,
            default: 'placeholders'
        },
    },
    data() {
        return {
            isLoading: false,
            options: [],
        };
    },
    computed: {
        getOptions() {
            return [
                {
                    'label': this.$t('words.yes'),
                    'value': 'yes'
                },
                ...this.options,
                {
                    'label': this.$t('words.other'),
                    'value': 'other'
                }
            ];
        },
        isStatusYes() {
            return this.status === 'yes';
        },
        isStatusOther() {
            return this.status === 'other';
        },
    },
    methods: {
        async fetchBloodDonorStatuses() {
            this.isLoading = true;

            try {
                const response = await window.axios.get('/blood-donors/plasma-statuses');

                this.options = response.data.data;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;

                this.$toastException(error);
            }
        },
        onUpdateBloodDonorStatus(name, value) {
            this.$emit('update', name, value);
        },
        onDeleteAttachmentEvent(file) {
            this.$emit('remove-uploaded-file', file);
        },
        onDownloadAttachmentEvent(file) {
            this.$emit('download-uploaded-file', file);
        },
        hasPermission(permission) {
            return this.$can
                ? this.$can(permission)
                : false;
        },
        onPreviewAttachmentEvent(file) {
            this.$emit('preview-uploaded-file', file);
        },
    },
    async created() {
        await this.fetchBloodDonorStatuses();
    }
}
</script>